import { useMutation } from '@tanstack/react-query';
import { useOrg } from 'src/shared/contexts/OrgContext';

type InvokeExtractionModelParams = {
  integrationId: string;
  threadId: string;
  modelId: string;
};

type InvokeExtractionModelResponse = {
  modelId: string;
  versionNumber: number;
  prediction: Record<string, unknown>;
};

export function useInvokeExtractionModel() {
  const { orgFetch } = useOrg();

  return useMutation({
    mutationFn: async (params: InvokeExtractionModelParams): Promise<InvokeExtractionModelResponse> => {
      const res = await orgFetch<InvokeExtractionModelResponse>('/api/v2/next-gen-models/extraction/invoke', {
        method: 'POST',
        body: JSON.stringify({
          integrationId: params.integrationId,
          threadId: params.threadId,
          modelId: params.modelId,
        }),
      });

      if (!res.ok) {
        throw new Error('Failed to invoke extraction model');
      }

      return res.json();
    },
  });
}
